/* @ngInject */
function formattedHashtag () {
  return function (string) {
    return `#${string}`
  }
}

export { formattedHashtag }
